import BricolageGrotesqueBold from './BricolageGrotesque-Bold.ttf'
import BricolageGrotesqueExtraLight from './BricolageGrotesque-ExtraLight.ttf'
import BricolageGrotesqueLight from './BricolageGrotesque-Light.ttf'
import BricolageGrotesqueMedium from './BricolageGrotesque-Medium.woff2'
import BricolageGrotesqueSemibold from './BricolageGrotesque-SemiBold.woff2'

const BricolageGrotesque = `
  @font-face {
    font-family: 'Bricolage Grotesque';
    src: url(${BricolageGrotesqueExtraLight}) format('truetype');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }

    @font-face {
    font-family: 'Bricolage Grotesque';
    src: url(${BricolageGrotesqueLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Bricolage Grotesque';
    src: url(${BricolageGrotesqueMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Bricolage Grotesque';
    src: url(${BricolageGrotesqueSemibold}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

    @font-face {
    font-family: 'Bricolage Grotesque';
    src: url(${BricolageGrotesqueBold}) format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
`

export default BricolageGrotesque
